import React from 'react';
import { CTA_LABEL, scrollToBuy } from '../utils/constants';
type CtaButtonProps = {
  label?: string;
  className?: string;
  href?: string;
};
const BASE = 'inline-flex w-full max-w-md items-center justify-center rounded-full bg-green px-4 py-3 text-center font-head text-[15px] uppercase leading-tight tracking-wide text-white shadow-[0_5px_0_0_#377030] transition-colors duration-150 ease-out hover:bg-green-dark active:translate-y-[2px] active:shadow-[0_3px_0_0_#377030] sm:max-w-lg sm:px-7 sm:py-4 sm:text-xl';
export function CtaButton({
  label = CTA_LABEL,
  className = '',
  href
}: CtaButtonProps) {
  if (href) {
    return <a href={href} className={`${BASE} ${className}`} data-id="element-63" data-mp="109u16fyr55qv">
        {label}
      </a>;
  }
  return <button type="button" onClick={scrollToBuy} className={`${BASE} ${className}`} data-id="element-64" data-mp="vcleq36kmfjt">
      {label}
    </button>;
}